export default {
  namespaced: true,
  state: {
    affiliates: [],
    affiliateSelect: null,
    filterAffiliate: null,
    dialogAffiliate: false,
    dialogUploadBonusAffiliate: false,
    dialogAffiliatePause: false,
    dialogMediaKit: false,
    affiliateBonus: [],
    filterAffiliateBonus: null
  },
  getters: {
    affiliates: (state) => state.affiliates,
    affiliateSelect: (state) => state.affiliateSelect,
    filterAffiliate: (state) => state.filterAffiliate,
    dialogAffiliate: (state) => state.dialogAffiliate,
    dialogUploadBonusAffiliate: (state) => state.dialogUploadBonusAffiliate,
    dialogAffiliatePause: (state) => state.dialogAffiliatePause,
    dialogMediaKit: (state) => state.dialogMediaKit,
    affiliateBonus: (state) => state.affiliateBonus,
    filterAffiliateBonus: (state) => state.filterAffiliateBonus
  },
  mutations: {
    SET_AFFILIATES(state, payload) {
      state.affiliates = payload;
    },
    SET_AFFILIATE_SELECT(state, payload) {
      state.affiliateSelect = payload;
    },
    SET_FILTER_AFFILIATE(state, payload) {
      state.filterAffiliate = payload;
    },
    SET_DIALOG_AFFILIATE(state, payload) {
      if (payload.value) {
        state.affiliateSelect = payload.value;
        state.dialogAffiliate = true;
      } else {
        state.dialogAffiliate = payload;
        state.affiliateSelect = null;
      }
    },
    SET_DIALOG_UPLOAD_BONUS_AFFILIATE(state, payload) {
        state.dialogUploadBonusAffiliate = payload;
    },

    SET_DIALOG_AFFILIATE_PAUSE(state, payload) {
        if(payload.value) {
            state.affiliateSelect = payload.value;
            state.dialogAffiliatePause = true;
        } else {
            state.affiliateSelect = null;
            state.dialogAffiliatePause = false;
        }
    },

    SET_DIALOG_MEDIA_KIT(state, payload) {
      state.dialogMediaKit = payload;
    },

    SET_AFFILIATE_BONUS(state, payload) {
      state.affiliateBonus = payload;
    },
    SET_FILTER_AFFILIATE_BONUS(state, payload) {
      state.filterAffiliateBonus = payload;
    }
  },
  actions: {
    ActionSetAffiliates({ commit }, payload) {
      commit('SET_AFFILIATES', payload);
    },
    ActionSetAffiliateSelect({ commit }, payload) {
      commit('SET_AFFILIATE_SELECT', payload);
    },
    ActionSetFilterAffiliate({ commit }, payload) {
      commit('SET_FILTER_AFFILIATE', payload);
    },
    ActionSetDialogAffiliate({ commit }, payload) {
      commit('SET_DIALOG_AFFILIATE', payload);
    },
    ActionSetDialogUploadBonusAffiliate({ commit }, payload) {
      commit('SET_DIALOG_UPLOAD_BONUS_AFFILIATE', payload);
    },

    ActionSetDialogAffiliatePause({ commit }, payload) {
      commit('SET_DIALOG_AFFILIATE_PAUSE', payload);
    },

    ActionSetDialogMediaKit({ commit }, payload) {
      commit('SET_DIALOG_MEDIA_KIT', payload);
    },

    ActionSetAffiliateBonus({ commit }, payload) {
      commit('SET_AFFILIATE_BONUS', payload);
    },
    ActionSetFilterAffiliateBonus({ commit }, payload) {
      commit('SET_FILTER_AFFILIATE_BONUS', payload);
    }
  }
};
